import { render, staticRenderFns } from "./customersalesdelivered.vue?vue&type=template&id=3ed38621&scoped=true"
import script from "./customersalesdelivered.vue?vue&type=script&lang=js"
export * from "./customersalesdelivered.vue?vue&type=script&lang=js"
import style0 from "./customersalesdelivered.vue?vue&type=style&index=0&id=3ed38621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed38621",
  null
  
)

export default component.exports